import React, { forwardRef } from 'react';
import cx from 'classnames';

import type { HeroProps } from './Hero.types';

import styles from './Hero.module.scss';

const Hero = forwardRef<HTMLDivElement, HeroProps>(({ buttons, className, image, subtitle, title }, ref) => {
	return (
		<section ref={ref} className={cx(styles.hero, className)} data-testid="Hero">
			<div className={styles.heroWrapper}>
				<div className={styles.heroContent}>
					<h1>{title}</h1>
					{subtitle && <p data-thc-style-override>{subtitle}</p>}
					{!!buttons && <footer>{buttons}</footer>}
				</div>
				<svg
					className={styles.mobileSvg}
					fill="none"
					height="88"
					preserveAspectRatio="none"
					viewBox="0 0 477 88"
					width="477"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M.5.5h476v9.57A15.5 15.5 0 0 1 465.12 25L242.63 86.35c-2.7.74-5.54.74-8.24 0L11.9 25A15.5 15.5 0 0 1 .5 10.07V.5Z"
						fill="var(--thc-color-off-black)"
						stroke="var(--product-accent)"
						strokeWidth="1"
						vectorEffect="non-scaling-stroke"
					/>
				</svg>
				<svg
					className={styles.desktopSvg}
					fill="none"
					height="477"
					preserveAspectRatio="none"
					viewBox="0 0 127 478"
					width="127"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M.5 476.5V.5h11.34a15.5 15.5 0 0 1 14.17 9.22l98.66 222.49a15.5 15.5 0 0 1 0 12.56L26 467.28a15.5 15.5 0 0 1-14.17 9.22H.5Z"
						fill="var(--thc-color-off-black)"
						stroke="var(--product-accent)"
						strokeWidth="1"
						vectorEffect="non-scaling-stroke"
					/>
				</svg>
			</div>
			{image && (
				<div className={styles.image}>
					<picture>
						<source srcSet={image.avif} type="image/avif" />
						{image.webp && <source srcSet={image.webp} type="image/webp" />}
						<img alt="" decoding="async" height={image.height} loading="lazy" src={image.png} width={image.width} />
					</picture>
				</div>
			)}
		</section>
	);
});

export default Hero;
